import { Box } from "@mui/material";
import ProcessBlock from "./ProcessBlock";
import { useHistory, useRouteMatch } from "react-router-dom";
import modules from "../modules/modules";
import { useSelector, useDispatch } from "react-redux";
import { useCallback, useEffect, useState } from "react";
import {
  submitStatusSelector,
  setSubmitStatus,
  applicantSelector,
} from "../../../store/applicantsSlice";
import {
  getGeneralInfoProgress,
  getFinancingProgress,
  getSchedulesProgress,
} from "../helpers/GifService/applicantService";
import { proposalSelector } from "../../../store/proposalSlice";
import { resetServiceFunction } from "../../../store/formSlice";

export default function ProcessBar({ baseurl }) {
  const history = useHistory();
  const dispatch = useDispatch();
  const { path } = useRouteMatch();
  const proposal = useSelector(proposalSelector);
  const applicant = useSelector(applicantSelector);
  const submitStatus = useSelector(submitStatusSelector);
  const [programModules, setProgramModules] = useState(modules);

  const IsActive = (route) => {
    const match = useRouteMatch({
      path: `${baseurl}${route}`,
      strict: false,
    });
    if (!match) return false;
    return true;
  };

  const handleOnClick = (module) => {
    dispatch(resetServiceFunction());
    history.push(`${baseurl}${module.path}`);
  };

  const findStatus = useCallback(
    (label) => {
      if (label === "General Information") {
        return submitStatus.generalInfo;
      }
      if (label === "Budget") {
        return submitStatus.financing;
      }
      if (label === "Project Schedules") {
        return submitStatus.schedules;
      }
      if (label === "Additional Information") {
        return submitStatus.miscellaneous;
      }
      return 0;
    },
    [submitStatus]
  );

  const updateStatus = useCallback(async () => {
    var status = {};
    if (applicant === null || proposal === null) return;
    const proposalId = proposal.id;
    const applicantId = applicant.id;
    if (path.includes("generalinformation")) {
      const generalInfo = await getGeneralInfoProgress({
        proposalId,
        applicantId,
      });
      if (generalInfo !== submitStatus.generalInfo) {
        status = { ...submitStatus, generalInfo };
      }
    }
    if (path.includes("projectfinancing")) {
      const financing = await getFinancingProgress({ proposalId, applicantId });
      if (financing !== submitStatus.financing) {
        status = { ...submitStatus, financing };
      }
    }
    if (path.includes("projectschedules")) {
      const schedules = await getSchedulesProgress({ proposalId, applicantId });
      if (schedules !== submitStatus.schedules) {
        status = { ...submitStatus, schedules };
      }
    }
    // if (path.includes("miscellaneous")) {
    //   const miscellaneous = await getMiscellaneousProgress({ proposalId });
    //   if (miscellaneous !== submitStatus.miscellaneous) {
    //     status = { ...submitStatus, miscellaneous };
    //   }
    // }
    if (
      status.generalInfo !== undefined &&
      status.financing !== undefined &&
      status.schedules !== undefined
      // status.miscellaneous !== undefined
    )
      dispatch(setSubmitStatus(status));
    return false;
  }, [dispatch, path, proposal, applicant, submitStatus]);

  useEffect(() => {
    if (proposal === null) return;
    let filterModules = modules
    .filter(m => m.statuses.length === 0 || m.statuses.includes(proposal.status))
    .filter(m => m.programs.length === 0 || m.programs.includes(proposal.programType));
    setProgramModules(filterModules);
  }, [proposal]);

  useEffect(() => {
    return () => {
      updateStatus();
    };
  }, [updateStatus]);

  return (
    <Box className="stepper" maxWidth="lg">
      {programModules.length>1&&
      programModules.map((m) => (
        <ProcessBlock
          onClick={() => handleOnClick(m)}
          key={m.path}
          text={m.headerText}
          active={IsActive(m.path)}
          status={findStatus(m.headerText)}
        />
      ))}
    </Box>
  );
}
